import { styled } from "@mui/material/styles";
import Container from "@mui/material/Container";

export const StyledContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
